import React, { Component } from 'react'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import CacheManager from '../../../cache/CacheManager'
import CacheKeys from '../../../cache/CacheKeys'
import ProjectUI from './ProjectUI.js'

class ProjectSF extends Component {
  handleDownloadFile = (fileName) => {
    const loanId = this.props.loan ? this.props.loan.loanId : null;
    if (!loanId || !fileName) return;
    RestApiUtils.get(this.props.context,
      `/api/su/loans/${loanId}/files/${fileName}/fileDownloadSignedUrl`,
      (response) => {
        if (response.errorList && response.errorList.length === 0 && response.signedUrl && response.signedUrl.signedUrl) {
          window.open(response.signedUrl.signedUrl, '_blank');
        }
      },
      null,
      null
    );
  }
  
  handleDownloadCustomerFile = (fileName) => {
    const loanId = this.props.loan ? this.props.loan.loanId : null;
    const accountId = (this.state.project && this.state.project.accountId) || (this.props.loan ? this.props.loan.accountId : null);
    if (!loanId || !accountId || !fileName) return;
    RestApiUtils.get(this.props.context,
      `/api/su/accounts/${accountId}/loans/${loanId}/customerFiles/${encodeURIComponent(fileName)}/fileDownloadSignedUrl`,
      (response) => {
        if (response && response.errorList && response.errorList.length === 0 && response.signedUrl && response.signedUrl.signedUrl) {
          window.open(response.signedUrl.signedUrl, '_blank');
        }
      },
      null,
      null
    );
  }
  
  constructor(props) {
    super(props)
    this.state = {
      project: null,
      errorList: null,
      loading: false,
      lastProjectId: null // Track the last project ID to prevent duplicate calls
    }
  }

  render() {
    return (
      <ProjectUI
        context={this.props.context}
        loan={this.props.loan}
        project={this.state.project}
        projectFileList={this.state.projectFileList}
        onDownloadFileClick={this.handleDownloadFile}
        onDownloadCustomerFileClick={this.handleDownloadCustomerFile}
        onRefreshClick={this.onRefreshClick}
        loading={this.state.loading}
        errorList={this.state.errorList}
      />
    )
  }

  componentDidMount() {
    // Only load project if loan and projectId are available
    if (this.props.loan && this.props.loan.projectId) {
      this.getProject(this.props.loan.projectId);
    } else {
      this.setState({ project: null, errorList: null, loading: false });
    }
  }

  componentDidUpdate(prevProps) {
    let prevProjectId = prevProps.loan ? prevProps.loan.projectId : null;
    let currentProjectId = this.props.loan ? this.props.loan.projectId : null;
    
    // Only make API call if project ID actually changed and we haven't already loaded this project
    if (prevProjectId !== currentProjectId && currentProjectId && currentProjectId !== this.state.lastProjectId) {
      this.getProject(currentProjectId);
    }
    
    // Clear project if no project ID
    if (!currentProjectId && this.state.project !== null) {
      this.setState({ project: null, errorList: null, loading: false, lastProjectId: null });
    }
  }

  getProject = (projectId) => {
    // Prevent duplicate calls for the same project
    if (this.state.lastProjectId === projectId && this.state.project !== null) {
      return;
    }
    
    this.setState({ loading: true, errorList: null, lastProjectId: projectId });
    
    const loanId = this.props.loan ? this.props.loan.loanId : null;
    let cacheManager = new CacheManager({
      resource: loanId ? `/api/su/loans/${loanId}/project/${projectId}` : `/api/su/projects/${projectId}`,
      cacheKey: CacheKeys.Project(projectId),
      callback: this.getProjectCallback,
      ttlInSecs: 300
    });
    cacheManager.getObject2(this.props.context);
  }

  getProjectCallback = (response) => {
    this.setState({ 
      errorList: response.errorList, 
      project: response.project,
      projectFileList: response.projectFileList || [],
      loading: false
    })
  }

  onRefreshClick = () => {
    // Remove project cache and reload project
    const loan = this.props.loan;
    if (loan && loan.projectId) {
      CacheManager.removeObject(CacheKeys.Project(loan.projectId));
      this.setState({ project: null, errorList: null, loading: false, lastProjectId: null });
      this.getProject(loan.projectId);
    }
    // Optionally, also call parent's refresh if needed
    if (this.props.onRefreshClick) {
      this.props.onRefreshClick();
    }
  }
}

export default ProjectSF
